import { Trophy, TrendUp, Coins } from '@phosphor-icons/react';
import { rupiah, num } from '../../lib/format';

const CARDS = [
  { key: 'terlaris', title: 'Produk Terlaris', icon: Trophy, tone: 'text-amber-500', value: (r) => `${num(r.qty_terjual, 2)} unit`, share: (r) => r.share_qty, shareLabel: 'dari unit terjual' },
  { key: 'omzet_tertinggi', title: 'Omzet Tertinggi', icon: TrendUp, tone: 'text-blue-600', value: (r) => rupiah(r.omzet), share: (r) => r.share_omzet, shareLabel: 'dari total omzet' },
  { key: 'laba_tertinggi', title: 'Kontribusi Laba Tertinggi', icon: Coins, tone: 'text-emerald-600', value: (r) => rupiah(r.laba_total), share: (r) => r.share_laba, shareLabel: 'dari total laba' },
];

export const TopProducts = ({ top }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    {CARDS.map((c) => {
      const r = top?.[c.key];
      return (
        <div key={c.key} className="stat-card" data-testid={`top-${c.key}`}>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">{c.title}</span>
            <c.icon size={26} weight="duotone" className={c.tone} />
          </div>
          {r ? (
            <>
              <div className="mt-2 font-display text-xl font-semibold truncate" data-testid={`top-${c.key}-name`}>{r.label}</div>
              <div className="flex items-baseline justify-between mt-1">
                <span className="tabular-nums font-medium">{c.value(r)}</span>
                <span className="text-xs text-muted-foreground">{num(c.share(r), 1)}% {c.shareLabel}</span>
              </div>
              <div className="mt-3 h-1.5 rounded-full bg-secondary overflow-hidden">
                <div className="h-full bg-primary rounded-full" style={{ width: `${Math.min(c.share(r), 100)}%` }} />
              </div>
            </>
          ) : (
            <div className="mt-3 text-sm text-muted-foreground">Belum ada penjualan</div>
          )}
        </div>
      );
    })}
  </div>
);
